module.exports = __webpack_public_path__ + "img/upload.829a2298215f6adce1a20a1e355db07b.829a2298.png";